<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="about">

        <div class="about-right">

         
            <el-page-header  @back="goBack">
            </el-page-header>
        <div class="chatnametitle" v-if="kefuname">{{ kefuname }}</div>
          <div class="chatnametitle" v-else>星环琪迹</div>
          <div class="content" ref="scrollDiv">
           
            <div class="chatcontent" v-for="(item, i) in chatItems" :key="i">
              <div class="chat-user-1" v-if="!(item.fromUserId == me)">

                <router-link :to="{path:'/mycenter',query:{roleId:item.fromUserId}}"> <img class="chat-user-1-headicon" :src="imgUrl + item.mePic" v-if="item.mePic" />
                  <img class="chat-user-1-headicon" src="../assets/images/mycenterheadpicture.png" v-else /></router-link>
                <div class="flex">
                  <div class="chatname" v-if="item.id">{{item.mininame}}
                    <span class="time">{{item.createTime.substr(0,16)}}</span></div>
                  <div v-if="item.contentType === 0">
                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                  </div>
                  <div class="chat-user-1-text" v-if="item.contentType === 1" :class="['image-container']">
                    <span v-html="setKeyWord1(item.content)"></span>
                  </div>
                  <div v-if="item.contentType === 2">
                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                  </div>
                  <div v-if="item.contentType == 3">
                    <div class="chat-user-1-text" @click="openFile(imgUrl+item.content)">文件下载</div>
                  </div>
                </div>
              </div>
              <div class="chat-user-2" v-else>
                <router-link :to="{path:'/mycenter',query:{roleId:item.fromUserId}}"><img class="chat-user-2-headicon" :src="imgUrl + item.mePic" v-if="item.mePic" />
                  <img class="chat-user-2-headicon" src="../assets/images/mycenterheadpicture.png" v-else /></router-link>
                   <div class="flex_2">
                    <span class="time_me">{{item.createTime.substr(0,16)}}</span>
                <div v-if="item.contentType === 0">
                  <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                </div>
                <div class="chat-user-2-text" v-if="item.contentType === 1">
                  <span v-html="setKeyWord2(item.content)"></span>
                </div>
                <div v-if="item.contentType === 2">
                  <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>
                </div>
                <div v-if="item.contentType == 3">
                  <div class="chat-user-2-text" @click="openFile(imgUrl+item.content)" :class="['image-container']">文件下载</div>
                </div>
                </div>
              </div>
            </div>
          </div>

          <div class="bottom">
            <div class="emopackage">
              <img class="emoimg" v-for="(item, i) in emoItems" :key="i" :src="imgUrl + item.icon" @click="sendimg(item.icon)" />
            </div>
            <div class="dialog_icon_total">
              <div>
                <img class="dialog_icon" @click="showexpression" src="../assets//images/expression.png" />
              </div>

              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile1" :on-success="updatepicture1" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif">
                <div>
                  <img class="dialog_icon" src="../assets//images/photo.png" />
                </div>
              </el-upload>
              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile2" :on-success="updatepicture2" accept=".zip,.doc,.docx,.xlsx,.xls,.txt,.ppt,.pptx,.pdf">
                <img class="dialog_icon" src="../assets/images/file.png" />
              </el-upload>

              <!-- <el-input class="textarea_submit"
                  v-model="textarea"
                  @input="onInput"
                  @keydown.native="handleKeyCode($event)"
                /> -->
            </div>

            <!-- <el-input class="textarea_submit" type="textarea" :rows="2" placeholder="请输入文字" v-model="textarea" @keydown.native="handleKeyCode($event)">
            </el-input> -->
  <quill-editor class="ql-editor" v-model="textarea" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)" @keydown.native="handleKeyCode($event)" id="editor">
            </quill-editor>
            <el-button type="primary" class="submit" @click="sendmessage()" round>发送</el-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<script>
import transparentheaders from "../components/transparentheaders.vue";
import {
  home,
  token,
  queryById,
  addchatRecordServer,
  emojisList,
  addchat,
  chatRecordServer
} from "../api/api";
import {
  Thumbs
} from "swiper";
import Quill from 'quill';
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径 
const chatimgItems = [];
const emoItems = [];
const chatItems = [

];

export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 8) + "...";
      }
      return value;
    },
    ellipsisnote(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 9) + "...";
      }
      return value;
    }
  },
  components: {
    transparentheaders,

  },
  data() {
    return {
      msg: "",
      activeNames: ['1'],
      id: "", //圈子
      join: "", //圈子限制
      textarea: "",
      searchvalue: "",
      emoItems, //存放表情包
      chatimgItems, //存放发送消息的表情
      chatItems,
      userid: "",
      activeIndex: '1',
      nums: [],
      dialogFormVisible: false,
      imgUrl,
      kefuid: "",
      kefuname: "",
      multipartFile1: {
        biz: "kefu"
      }, //文件上传参数
      multipartFile2: {
        biz: "file",
        'content-type': 'multipart/form-data'

      }, //文件上传参数
      editorOption: {
        modules: {
          toolbar: [

          ],
          keyboard: {
            bindings: {
              // 阻止回车键输入 br 标签
              noBreak: {
                key: 13,
                handler: function (e) {
                  return false;
                }
              }
            }
          }
        },
        placeholder: '请输入文字',
      },
    };
  },
  computed: {
    me() {
      return JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
    }
  },
  created() {
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id

  },
  mounted() {
    this.kefuid = this.$route.query.id
    token().then(res => {
      if (res.data.code == 200) {

      }
    });
    home().then(res => {
      if (res.data.code == 200) {

      }
    });
    queryById({
      id: this.kefuid
    }).then(res => {
      if (res.data.code == 200) {
        this.kefuname = res.data.result.mininame;
      }
    });
    this.getchatRecord();
    emojisList().then(res => {
      if (res.data.code == 200) {
        this.emoItems = res.data.result
      }
    });
  },
  methods: {

    updatepicture1(res) {
      let data = {

        content: res.message,
        contentType: 2,
        fromUserId: this.userid,
        toUserId: this.kefuid,
      }
      console.log("111")
      addchatRecordServer(data).then(res => {
        if (res.data.code == 200) {
          this.getchatRecord();

        }

      });
    },
    updatepicture2(res) {
      let data = {
        content: res.message,
        contentType: 3,
        fromUserId: this.userid,
        toUserId: this.kefuid,

      }
      addchatRecordServer(data).then(res => {
        if (res.data.code == 200) {
          this.getchatRecord();
        }

      });
    },
    goBack() {
      this.findVisible = false;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    // changefindVisible() {
    //   this.findVisible = true;
    //   console.log(this.findVisible)
    // },
    sendmessage() {
      if (this.textarea&&!(this.textarea.trim() === "")) {
        let data = {

          content: this.textarea.match(/\<img.*?\>/) ? this.textarea : this.textarea.replace(/ /g, '&nbsp;'),
          contentType: 1,
          fromUserId: this.userid,
          toUserId: this.kefuid,
        }
        addchatRecordServer(data).then(res => {
          if (res.data.code == 200) {
            this.getchatRecord();
          }

        });
        this.textarea = ""
      } else {
        this.msg = "发送内容不能为空"
        this.open();
      }

    },

    handleScrollBottom() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({
          top: scrollElem.scrollHeight,
          behavior: "smooth"
        });
      });
    },
    clear() {
      this.value = "";
    },

    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {

      });
    },
     handleKeyCode(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation();//Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        this.sendmessage();
      }

    },
    handleSendText() {
      // 处理消息发送逻辑
      this.sendmessage();
    },

    setKeyWord1(str) {
      if (this.findvalue === true) {
        const reg = new RegExp(this.searchvalue, "g");

        return str.replace(
          reg,
          `<span style="color: rgb(55,128,237);">${this.searchvalue}</span>`
        );
      } else {
        return str;
      }
    },
    setKeyWord2(str) {
      if (this.findvalue === true) {
        const reg = new RegExp(this.searchvalue, "g");
        return str.replace(
          reg,
          `<span style="color: rgb(195,229,255);">${this.searchvalue}</span>`
        );
      } else {
        return str;
      }
    },
    reset() {
      this.findvalue = false;
    },

    clearTextarea() {
      this.textarea = "";
    },
    showexpression() {
      var emo = document.querySelector(".emopackage");

      if ((emo.style.display === "block")) {
        emo.style.display = "none";
      } else {
        emo.style.display = "block";
      }
    },

    init() {
      emojisList().then(res => {
        if (res.data.code == 200) {
          this.emoItems = res.data.result
        }
      });

      this.loadAll();
      this.getchatRecord();
    },

    userNum(id) {
      let a = this.nums.filter(item => {
        return item.id == id
      })
      return a[0].use
    },

    getchatRecord() {
      chatRecordServer({
        me: this.userid,
        you: this.kefuid,
        pageNo: 1,
        pageSize: 20
      }).then(res => {
        if (res.data.code == 200) {
          this.chatItems = res.data.result.records.reverse()
          this.handleScrollBottom()
        }
      });
       this.timer = setInterval(() => {
          chatRecordServer({
             me: this.userid,
        you: this.kefuid,
        pageNo: 1,
        pageSize: 20
          }).then(res => {
            if (res.data.code == 200) {
              // this.chatItems = res.data.result.records.reverse();
              
          
              // this.handleScrollBottom();
               const newChatItems = res.data.result.records.reverse();
      
      // 判断 chatItems 数组长度增加
      if (newChatItems.length > this.chatItems.length) {
        this.chatItems = newChatItems;
        this.handleScrollBottom();
      }
            }
          });

        },
        3000)
    },

    openFile(url) {
      window.open(url)
    },
    sendimg(e) {
      let data = {
        fromUserId: this.userid,
        toUserId: this.kefuid,
        content: e,
        contentType: 0,

      }
  var res

      res = imgUrl + e
      console.log(res)
      if (res) {
        // 获取光标所在位置
        let quill = this.$refs.myQuillEditor.quill;
        quill.focus()
        let length = quill.getSelection().index
        console.log(length)
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, "image", res);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        // 提示信息，需引入Message
        this.$message.error("图片插入失败！");
      }
      // addchatRecordServer(data).then(res => {
      //   if (res.data.code == 200) {
      //     this.getchatRecord();
      //   }
      // });
    },
    goBack() {
      this.$router.go(-1)
    }
  },

};
</script>

<style lang="scss" scoped>
.about {
  margin-top: 70px;
  display: flex;


.about-right {
 
  display: flex;
  flex-direction: column;
  width: 1080px;
   background: white;
}
}

.content {
  height: 500px;
  border-bottom: solid 1px rgb(237, 245, 255);
  overflow: auto;
  padding: 20px;

}

.bottom {
  padding: 0px 50px 150px;
  height: 360px;
}

.background {
  padding: 20px;
  background: rgb(234, 242, 250);

  // width: 100%;
}
>>>.ql-toolbar.ql-snow {
  border: none;
  height: 0px !important;

  border-bottom: 1px solid #ccc;
}
.ql-container.ql-snow {
  border: 1px solid #2c97e9;

  height: 150px;
  z-index: 9999;
}

.white {
  background: white;
  z-index: 9999;
}

.headicon {
  margin-right: 10px;
}

.submit {
  height: 40px;
  width: 100px;
  background-color: rgb(10, 108, 255);
  font-size: 16px;
  font-family: "HarmonyOS_Sans_SC";
  color: rgb(255, 255, 255);
  line-height: 3px;
  margin-top: 10px;
  margin-left: 876px;
}

.dialog_icon {
  margin-right: 10px;
  margin-left: 4px;
  cursor: pointer;
}

.dialog_icon_total {
  display: flex;
  margin-left: 48px;
  margin-top: 20px;
  margin-bottom: 20px;
}

>>>.bottom .el-textarea__inner {
  margin-left: 40px;
  width: 830px !important;
  height: 70px !important;
  margin-top: -10px;
  border-width: 1px;
  border-color: rgb(204, 227, 255);
  border-style: solid;
  border-radius: 10px;
  margin-bottom: 10px;
}

>>>.el-textarea__inner {
  resize: none;
  height: 60px;
}

::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.chatcontent {
  padding: 20px;
}

.chat-user-1 {
  display: flex;

  margin-top: 5px;
  font-size: 14px;
  font-family: "Adobe Heiti Std";
  color: rgb(51, 51, 51);

}

.chat-user-2 {
  margin-top: 5px;
  display: flex;
  flex-direction: row-reverse;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(255, 255, 255);
  line-height: 1.714;
  text-align: justifyLeft;

}

.chat-user-1-text {
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
  max-width: 550px;
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  word-break: break-all;
  padding: 10px 22px;
}

.chat-user-2-text {
  border-radius: 10px;
  background-color: rgb(71, 145, 255);
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 550px;
  padding: 10px 22px;
  word-wrap: break-word;
  word-break: break-all;
}

.chat-user-1-headicon {
  margin-right: 15px;
  margin-left: 10px;
  align-self: flex-start;
  word-wrap: break-word; //英文换行
  height: 50px;
  width: 50px;
  border-radius: 50%
}

.chat-user-2-headicon {
  margin-left: 15px;
  margin-right: 10px;
  align-self: flex-start;
  word-wrap: break-word; //英文换行
  width: 50px;
  height: 50px;
  border-radius: 50%
}

>>>.el-button+.el-button {
  margin: 0%;
}

>>>.el-form-item__label {
  margin-top: 15px;
}

>>>.el-form-item__label {
  line-height: 5px;
}

.image-container img {
  width: 20px;
  height: 20px;
}
.emoimg {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 15px;
}

.emopackage {
  position: absolute;
  display: flex;
  word-wrap: break-word;
  width: 340px;
  max-height: 420px;
  padding: 5px;
  overflow: hidden;
  transform: translateY(-90px);
  margin-left: 50px;
  display: none;
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  background-color: white;
}

.dialogimg {
  width: 60px;
  height: 60px;
}

.dialogpiture {
  width: 120px;
  height: 120px;
}

>>>.el-upload-list__item {
  display: none;
}

>>>.el-upload-list__item-name {
  transition: none !important;
  display: none;
}

>>>.el-upload-list__item .el-icon-upload-success {
  display: none;
}

.el-menu {
  margin-top: 0px;

  margin-left: 30px;
}

.el-page-header {
  margin-left: 10px;
  margin-top: 10px;
}

>>>.el-page-header__left::after {
  display: none;
}

.dialogpiture {
  width: 60px;
  height: 60px;
}

.chatnametitle {
  display: fixed;
  text-align: center;
  color: rgb(71, 145, 255);
  font-size: 15px !important;
  border-bottom: solid 1px rgb(237, 245, 255);
  padding-bottom: 15px;
}
.flex_2 .dialogimg{
   float: right;
       margin-top: 5px;
}
.flex_2 .chat-user-2-text{
   float: right;
       margin-top: 5px;
}
.time_me {
  color: #aaa;
      font-size: 12px !important;
    margin-bottom: 10px;
}
.time {
   color: #aaa;
       font-size: 12px !important;
    margin-bottom: 10px;
}
.ql-snow .ql-editor img {
  width: 20px;
  height: 20px;
}

.ql-container.ql-snow {
  border: 1px solid #2c97e9;

  height: 150px;
  z-index: 9999;
}

</style>



// WEBPACK FOOTER //
// src/components/kefu.vue